import React from 'react';

/**
 *
 * Do NOT use this component directly. Use the Input component instead.
 *
 */

export default function CheckBox({
    label,
    sublabel,
    value,
    select = false,
    isSelected = false,
    isMulti = true,
    onChange = false,
    optionClass = '',
    style = null,
    ...props
}) {
    return (
        <span className="form-styling">
            <input
                className="radio-primary peer"
                onClick={select ? () => select(value) : null}
                type={isMulti ? 'checkbox' : 'radio'}
                id={props.id ?? `checkbox-${value}`}
                value={value}
                readOnly
                checked={isSelected}
                disabled={props.disabled}
                onChange={onChange ? (e) => onChange(e) : null}
            />
            <label
                htmlFor={props.id ?? `checkbox-${value}`}
                className={optionClass}
                style={style}>
                {props.image && (
                    <div className="mb-2 checkbox-image">
                        <img
                            src={props.image}
                            alt={label}
                            className="object-cover w-full rounded-sm max-h-28 aspect-square"
                        />
                    </div>
                )}
                {sublabel ? (
                    <span className="flex flex-col">
                        <span className="font-bold">{label}</span>
                        <span className="mt-1 text-sm font-light text-gray-600">
                            {sublabel}
                        </span>
                    </span>
                ) : (
                    <span>{label}</span>
                )}
            </label>
        </span>
    );
}
